/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetFragmentsListQueryResponse } from "../models/GetFragmentsList";

export function getGetFragmentsListUrl() {
  const res = { method: 'GET', url: `/fragments` as const }
  return res
}

/**
 * @summary List fragments with poster, social upload statuses and external delivery status (sort, filter, limit, page)
 * {@link /fragments}
 */
export async function getFragmentsList(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetFragmentsListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetFragmentsListUrl().url.toString(), ... requestConfig })
  return res.data
}